"use client"

import styled from "@emotion/styled"
import { MenuItem } from "@mui/material"

export const MultiSelectCheckbox = styled.span<{ $isSelected: boolean; $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid;
  transition: all 0.2s ease-in-out;
  border-color: ${({ $isSelected, $disabled, theme }) =>
    $disabled ? theme.colors.port.grey : $isSelected ? "transparent" : theme.colors.port.grey};
  background-color: ${({ $isSelected, $disabled, theme }) =>
    $disabled ? "rgba(230,230,230,0.4)" : $isSelected ? theme.colors.propBlue : "transparent"};

  svg {
    width: 10px;
    height: 10px;
  }
`

export const MultiSelectMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  padding: 4px 8px !important;
  min-height: unset !important;
  gap: 12px;

  &:hover {
    background-color: transparent !important;
  }

  &.Mui-selected {
    background-color: transparent !important;
  }
`

export const MultiSelectText = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #0e2846;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-inline-end: 36px;
  width: 100%;
  display: block;
`

export const ComingSoonBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 4px;
  border-radius: 8px;
  background-color: #0000fa;
  color: white;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;
`

export const StyledResultsCount = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 300;
  line-height: 150%;
  color: ${(props) => props.theme.colors.port.defaultTextColor};
  span {
    font-weight: 700;
  }
`

export const StyledClearIcon = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const StyledFieldIcon = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const selectMenuProps = {
  PaperProps: {
    sx: {
      backgroundColor: "white",
      border: "1px solid #e4e4e4",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(42, 42, 42, 0.12)",
      marginTop: "4px",
      "& .MuiList-root": {
        padding: 0,
      },
      "& .MuiMenuItem-root": {
        padding: "11px 24px",
        fontFamily: "var(--simpler-pro-full) !important",
        fontSize: "16px",
        fontWeight: 700,
        color: "#2a2a2a",
        textTransform: "uppercase",
        whiteSpace: "normal",
        wordBreak: "break-word",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 250, 0.04)",
        },
        "&.Mui-selected": {
          backgroundColor: "transparent",
          color: "#0000fa",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 250, 0.04)",
          },
        },
      },
    },
  },
}

export const multiSelectMenuProps = {
  PaperProps: {
    sx: {
      backgroundColor: "white",
      border: "1px solid #e4e4e4",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(42, 42, 42, 0.12)",
      marginTop: "4px",
      "& .MuiList-root": {
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      },
    },
  },
}
